import React, { useEffect, useState } from "react";
import slugify from "slugify";
import HeaderBottom from "../../components/HomePage/HeaderBottom";
import MarginTop from "../../MarginTop";
import { Link } from "react-router-dom";

const AddPage = () => {
  const [pageName, setPageName] = useState("");
  const [pageSEOTitle, setPageSEOTitle] = useState("");
  const [pageSlug, setPageSlug] = useState("");
  const [pages, setPages] = useState([]); // Store fetched pages

  // Automatically update slug when pageName changes
  useEffect(() => {
    if (pageName) {
      setPageSlug(
        slugify(pageName, {
          lower: true,
          strict: true,
          trim: true,
        })
      );
    }
  }, [pageName]);

  // Fetch pages from the backend
  useEffect(() => {
    fetch("https://aprilone-178ea8362c0b.herokuapp.com/page")
      .then((res) => res.json())
      .then((data) => setPages(data));
  }, []);

  const handlePage = (event) => {
    event.preventDefault();
    const pageData = { pageName, pageSEOTitle, pageSlug };

    fetch("https://aprilone-178ea8362c0b.herokuapp.com/add-page", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(pageData),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Page Added Successfully");
        setPages([...pages, pageData]); // Update state with the new page
      });
  };

  // Delete page function
  const handleDelete = async (slug) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this page?");
    if (confirmDelete) {
      try {
        const response = await fetch(`https://aprilone-178ea8362c0b.herokuapp.com/delete-page/${slug}`, {
          method: "DELETE",
        });

        const data = await response.json();
        if (response.ok) {
          alert(data.message);
          setPages((prevPages) => prevPages.filter((page) => page.pageSlug !== slug)); // Remove deleted page from state
        } else {
          alert(data.message);
        }
      } catch (error) {
        console.error("Error deleting page:", error);
      }
    }
  };

  return (
    <>
      <HeaderBottom />

      <div>
        <section id="services" className="services-area d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-12 text-center">
                <h2 className="mb-5 mt-5">Add New Page</h2>

                <form className="contact-form text-center" onSubmit={handlePage}>
                  <div className="row">
                    {/* Page Name */}
                    <div className="col-lg-12 col-md-12 mb-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control mb-3 "
                          placeholder="Page Name"
                          required
                          value={pageName}
                          onChange={(e) => setPageName(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Page SEO Title */}
                    <div className="col-lg-12 col-md-12 mb-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control mb-3 "
                          placeholder="Page SEO Title"
                          required
                          value={pageSEOTitle}
                          onChange={(e) => setPageSEOTitle(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Auto-generated Slug (Hidden) */}
                    <input type="hidden" value={pageSlug} />

                    {/* Submit Button */}
                    <div className="slider-btn text-center">
                      <button className="button-professional">Add Page</button>
                    </div>
                  </div>
                </form>

                {/* Display Pages in a Table */}
                <h3 className="mt-5">Page List</h3>
                <table className="table table-bordered table-striped table-hover">
                  <thead className="bg-primary text-white">
                    <tr>
                      <th>Sl No</th>
                      <th>Page URL</th>
                      <th>Page Name</th>
                      <th>SEO Title</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pages.map((page, index) => (
                      <tr key={page._id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">
                          {page.pageSlug === "" ? "Home (Default)" : page.pageSlug}
                        </td>
                        <td className="text-center">{page.pageName}</td>
                        <td className="text-center">{page.pageSEOTitle}</td>
                        <td className="text-center">
                          <Link
                            to={page.pageSlug === "" ? "/" : `/edit-page/${page.pageSlug}`}
                            className="btn btn-primary btn-lg me-2"
                          >
                            {page.pageSlug === "" ? "Default Page" : "Edit"}
                          </Link>
                          <button
                            className="btn btn-danger btn-lg"
                            onClick={() => handleDelete(page.pageSlug)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>

      <MarginTop />
    </>
  );
};

export default AddPage;
